import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';

const isBrowser = typeof window !== 'undefined';

/**
 * 端内标题点击
 */
export const handleNativeTitleClick = (item, e) => {
    e.preventDefault();

    if (/topic/.test(item.type)) {
        return Grounds.dispatch(item.link.type, item.link.url, {
            showtype: 'hotspottitleimg',
            ref: 'hot_merge',
        });
    }

    return Grounds.dispatch(item.hotLabel.link.type, item.hotLabel.link.url, {
        showtype: 'hotspottitleimg',
        ref: 'hot_merge',
    });
};

/**
 * 端外标题 a 标签跳转
 */
export const getWebTitleUrl = item => {
    if (item?.hotLabel?.link?.type === 'hotspotlist') {
        const params = item.hotLabel.link.url.split('?')[1];

        if (!isBrowser) return '';

        const url = location.href.replace(/hotNewsRank(\?)?|hotNewsShare404(\?)?/, `hotNewsSingleShare?${params}&`);

        return url;
    } else {
        return item?.hotLabel?.link?.weburl;
    }
};

/**
 * 计算视频时长
 * @param {Number} duration 视频时长 秒
 * @return {String} 格式化的时间00:00:00 / 00:00
 */
export const formatVideoDuration = duration => {
    let second = parseInt(duration);
    let minute = 0;
    let hour = 0;
    let formatedDuration = '';

    if (second >= 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
        if (minute >= 60) {
            hour = parseInt(minute / 60);
            minute = parseInt(minute % 60);
        }
    }

    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    hour = hour < 10 ? `0${hour}` : hour;

    if (parseInt(duration) < 60) {
        formatedDuration = `00:${second}`;
    }

    if (minute > 0) {
        formatedDuration = `${minute}:${second}`;
    }

    if (hour > 0) {
        formatedDuration = `${hour}:${minute}:${second}`;
    }

    return formatedDuration;
};

export const limitWords = (str, len) => {
    let max = len * 2;
    let num = 0;
    let strArr = str?.split?.('') || '';
    let result = [];

    while (strArr.length && num < max) {
        let word = strArr.shift();

        result.push(word);
        num += word.charCodeAt(0) > 127 ? 2 : 1;
    }

    return result.join('');
};
